const LANGUAGES = [
	{
		"abbr": "ab",
		"english": "Abkhaz"
	},
	{
		"abbr": "aa",
		"english": "Afar"
	},
	{
		"abbr": "af",
		"english": "Afrikaans"
	},
	{
		"abbr": "ak",
		"english": "Akan"
	},
	{
		"abbr": "sq",
		"english": "Albanian"
	},
	{
		"abbr": "am",
		"english": "Amharic"
	},
	{
		"abbr": "ar",
		"english": "Arabic"
	},
	{
		"abbr": "an",
		"english": "Aragonese"
	},
	{
		"abbr": "hy",
		"english": "Armenian"
	},
	{
		"abbr": "as",
		"english": "Assamese"
	},
	{
		"abbr": "av",
		"english": "Avaric"
	},
	{
		"abbr": "ae",
		"english": "Avestan"
	},
	{
		"abbr": "ay",
		"english": "Aymara"
	},
	{
		"abbr": "az",
		"english": "Azerbaijani"
	},
	{
		"abbr": "bm",
		"english": "Bambara"
	},
	{
		"abbr": "ba",
		"english": "Bashkir"
	},
	{
		"abbr": "eu",
		"english": "Basque"
	},
	{
		"abbr": "be",
		"english": "Belarusian"
	},
	{
		"abbr": "bn",
		"english": "Bengali; Bangla"
	},
	{
		"abbr": "bh",
		"english": "Bihari"
	},
	{
		"abbr": "bi",
		"english": "Bislama"
	},
	{
		"abbr": "bs",
		"english": "Bosnian"
	},
	{
		"abbr": "br",
		"english": "Breton"
	},
	{
		"abbr": "bg",
		"english": "Bulgarian"
	},
	{
		"abbr": "my",
		"english": "Burmese"
	},
	{
		"abbr": "ca",
		"english": "Catalan; Valencian"
	},
	{
		"abbr": "ch",
		"english": "Chamorro"
	},
	{
		"abbr": "ce",
		"english": "Chechen"
	},
	{
		"abbr": "ny",
		"english": "Chichewa; Chewa; Nyanja"
	},
	{
		"abbr": "zh",
		"english": "Chinese"
	},
	{
		"abbr": "cv",
		"english": "Chuvash"
	},
	{
		"abbr": "kw",
		"english": "Cornish"
	},
	{
		"abbr": "co",
		"english": "Corsican"
	},
	{
		"abbr": "cr",
		"english": "Cree"
	},
	{
		"abbr": "hr",
		"english": "Croatian"
	},
	{
		"abbr": "cs",
		"english": "Czech"
	},
	{
		"abbr": "da",
		"english": "Danish"
	},
	{
		"abbr": "dv",
		"english": "Divehi; Dhivehi; Maldivian;"
	},
	{
		"abbr": "nl",
		"english": "Dutch"
	},
	{
		"abbr": "dz",
		"english": "Dzongkha"
	},
	{
		"abbr": "en",
		"english": "English"
	},
	{
		"abbr": "eo",
		"english": "Esperanto"
	},
	{
		"abbr": "et",
		"english": "Estonian"
	},
	{
		"abbr": "ee",
		"english": "Ewe"
	},
	{
		"abbr": "fo",
		"english": "Faroese"
	},
	{
		"abbr": "fj",
		"english": "Fijian"
	},
	{
		"abbr": "fi",
		"english": "Finnish"
	},
	{
		"abbr": "fr",
		"english": "French"
	},
	{
		"abbr": "ff",
		"english": "Fula; Fulah; Pulaar; Pular"
	},
	{
		"abbr": "gl",
		"english": "Galician"
	},
	{
		"abbr": "ka",
		"english": "Georgian"
	},
	{
		"abbr": "de",
		"english": "German"
	},
	{
		"abbr": "el",
		"english": "Greek, Modern"
	},
	{
		"abbr": "gn",
		"english": "GuaranÃ­"
	},
	{
		"abbr": "gu",
		"english": "Gujarati"
	},
	{
		"abbr": "ht",
		"english": "Haitian; Haitian Creole"
	},
	{
		"abbr": "ha",
		"english": "Hausa"
	},
	{
		"abbr": "he",
		"english": "Hebrew (modern)"
	},
	{
		"abbr": "hz",
		"english": "Herero"
	},
	{
		"abbr": "hi",
		"english": "Hindi"
	},
	{
		"abbr": "ho",
		"english": "Hiri Motu"
	},
	{
		"abbr": "hu",
		"english": "Hungarian"
	},
	{
		"abbr": "ia",
		"english": "Interlingua"
	},
	{
		"abbr": "id",
		"english": "Indonesian"
	},
	{
		"abbr": "ie",
		"english": "Interlingue"
	},
	{
		"abbr": "ga",
		"english": "Irish"
	},
	{
		"abbr": "ig",
		"english": "Igbo"
	},
	{
		"abbr": "ik",
		"english": "Inupiaq"
	},
	{
		"abbr": "io",
		"english": "Ido"
	},
	{
		"abbr": "is",
		"english": "Icelandic"
	},
	{
		"abbr": "it",
		"english": "Italian"
	},
	{
		"abbr": "iu",
		"english": "Inuktitut"
	},
	{
		"abbr": "ja",
		"english": "Japanese"
	},
	{
		"abbr": "jv",
		"english": "Javanese"
	},
	{
		"abbr": "kl",
		"english": "Kalaallisut, Greenlandic"
	},
	{
		"abbr": "kn",
		"english": "Kannada"
	},
	{
		"abbr": "kr",
		"english": "Kanuri"
	},
	{
		"abbr": "ks",
		"english": "Kashmiri"
	},
	{
		"abbr": "kk",
		"english": "Kazakh"
	},
	{
		"abbr": "km",
		"english": "Khmer"
	},
	{
		"abbr": "ki",
		"english": "Kikuyu, Gikuyu"
	},
	{
		"abbr": "rw",
		"english": "Kinyarwanda"
	},
	{
		"abbr": "ky",
		"english": "Kyrgyz"
	},
	{
		"abbr": "kv",
		"english": "Komi"
	},
	{
		"abbr": "kg",
		"english": "Kongo"
	},
	{
		"abbr": "ko",
		"english": "Korean"
	},
	{
		"abbr": "ku",
		"english": "Kurdish"
	},
	{
		"abbr": "kj",
		"english": "Kwanyama, Kuanyama"
	},
	{
		"abbr": "la",
		"english": "Latin"
	},
	{
		"abbr": "lb",
		"english": "Luxembourgish, Letzeburgesch"
	},
	{
		"abbr": "lg",
		"english": "Ganda"
	},
	{
		"abbr": "li",
		"english": "Limburgish, Limburgan, Limburger"
	},
	{
		"abbr": "ln",
		"english": "Lingala"
	},
	{
		"abbr": "lo",
		"english": "Lao"
	},
	{
		"abbr": "lt",
		"english": "Lithuanian"
	},
	{
		"abbr": "lu",
		"english": "Luba-Katanga"
	},
	{
		"abbr": "lv",
		"english": "Latvian"
	},
	{
		"abbr": "gv",
		"english": "Manx"
	},
	{
		"abbr": "mk",
		"english": "Macedonian"
	},
	{
		"abbr": "mg",
		"english": "Malagasy"
	},
	{
		"abbr": "ms",
		"english": "Malay"
	},
	{
		"abbr": "ml",
		"english": "Malayalam"
	},
	{
		"abbr": "mt",
		"english": "Maltese"
	},
	{
		"abbr": "mi",
		"english": "MÄori"
	},
	{
		"abbr": "mr",
		"english": "Marathi (MarÄá¹­hÄ«)"
	},
	{
		"abbr": "mh",
		"english": "Marshallese"
	},
	{
		"abbr": "mn",
		"english": "Mongolian"
	},
	{
		"abbr": "na",
		"english": "Nauru"
	},
	{
		"abbr": "nv",
		"english": "Navajo, Navaho"
	},
	{
		"abbr": "nb",
		"english": "Norwegian BokmÃ¥l"
	},
	{
		"abbr": "nd",
		"english": "North Ndebele"
	},
	{
		"abbr": "ne",
		"english": "Nepali"
	},
	{
		"abbr": "ng",
		"english": "Ndonga"
	},
	{
		"abbr": "nn",
		"english": "Norwegian Nynorsk"
	},
	{
		"abbr": "no",
		"english": "Norwegian"
	},
	{
		"abbr": "ii",
		"english": "Nuosu"
	},
	{
		"abbr": "nr",
		"english": "South Ndebele"
	},
	{
		"abbr": "oc",
		"english": "Occitan"
	},
	{
		"abbr": "oj",
		"english": "Ojibwe, Ojibwa"
	},
	// {
	// 	"abbr": "cu",
	// 	"english": "Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic"
	// },
	{
		"abbr": "om",
		"english": "Oromo"
	},
	{
		"abbr": "or",
		"english": "Oriya"
	},
	{
		"abbr": "os",
		"english": "Ossetian, Ossetic"
	},
	{
		"abbr": "pa",
		"english": "Panjabi, Punjabi"
	},
	{
		"abbr": "pi",
		"english": "PÄli"
	},
	{
		"abbr": "fa",
		"english": "Persian (Farsi)"
	},
	{
		"abbr": "pl",
		"english": "Polish"
	},
	{
		"abbr": "ps",
		"english": "Pashto, Pushto"
	},
	{
		"abbr": "pt",
		"english": "Portuguese"
	},
	{
		"abbr": "qu",
		"english": "Quechua"
	},
	{
		"abbr": "rm",
		"english": "Romansh"
	},
	{
		"abbr": "rn",
		"english": "Kirundi"
	},
	{
		"abbr": "ro",
		"english": "Romanian"
	},
	{
		"abbr": "ru",
		"english": "Russian"
	},
	{
		"abbr": "sa",
		"english": "Sanskrit (Saá¹ská¹›ta)"
	},
	{
		"abbr": "sc",
		"english": "Sardinian"
	},
	{
		"abbr": "sd",
		"english": "Sindhi"
	},
	{
		"abbr": "se",
		"english": "Northern Sami"
	},
	{
		"abbr": "sm",
		"english": "Samoan"
	},
	{
		"abbr": "sg",
		"english": "Sango"
	},
	{
		"abbr": "sr",
		"english": "Serbian"
	},
	{
		"abbr": "gd",
		"english": "Scottish Gaelic; Gaelic"
	},
	{
		"abbr": "sn",
		"english": "Shona"
	},
	{
		"abbr": "si",
		"english": "Sinhala, Sinhalese"
	},
	{
		"abbr": "sk",
		"english": "Slovak"
	},
	{
		"abbr": "sl",
		"english": "Slovene"
	},
	{
		"abbr": "so",
		"english": "Somali"
	},
	{
		"abbr": "st",
		"english": "Southern Sotho"
	},
	{
		"abbr": "az",
		"english": "South Azerbaijani"
	},
	{
		"abbr": "es",
		"english": "Spanish; Castilian"
	},
	{
		"abbr": "su",
		"english": "Sundanese"
	},
	{
		"abbr": "sw",
		"english": "Swahili"
	},
	{
		"abbr": "ss",
		"english": "Swati"
	},
	{
		"abbr": "sv",
		"english": "Swedish"
	},
	{
		"abbr": "ta",
		"english": "Tamil"
	},
	{
		"abbr": "te",
		"english": "Telugu"
	},
	{
		"abbr": "tg",
		"english": "Tajik"
	},
	{
		"abbr": "th",
		"english": "Thai"
	},
	{
		"abbr": "ti",
		"english": "Tigrinya"
	},
	{
		"abbr": "bo",
		"english": "Tibetan Standard, Tibetan, Central"
	},
	{
		"abbr": "tk",
		"english": "Turkmen"
	},
	{
		"abbr": "tl",
		"english": "Tagalog"
	},
	{
		"abbr": "tn",
		"english": "Tswana"
	},
	{
		"abbr": "to",
		"english": "Tonga (Tonga Islands)"
	},
	{
		"abbr": "tr",
		"english": "Turkish"
	},
	{
		"abbr": "ts",
		"english": "Tsonga"
	},
	{
		"abbr": "tt",
		"english": "Tatar"
	},
	{
		"abbr": "tw",
		"english": "Twi"
	},
	{
		"abbr": "ty",
		"english": "Tahitian"
	},
	{
		"abbr": "ug",
		"english": "Uyghur, Uighur"
	},
	{
		"abbr": "uk",
		"english": "Ukrainian"
	},
	{
		"abbr": "ur",
		"english": "Urdu"
	},
	{
		"abbr": "uz",
		"english": "Uzbek"
	},
	{
		"abbr": "ve",
		"english": "Venda"
	},
	{
		"abbr": "vi",
		"english": "Vietnamese"
	},
	{
		"abbr": "vo",
		"english": "VolapÃ¼k"
	},
	{
		"abbr": "wa",
		"english": "Walloon"
	},
	{
		"abbr": "cy",
		"english": "Welsh"
	},
	{
		"abbr": "wo",
		"english": "Wolof"
	},
	{
		"abbr": "fy",
		"english": "Western Frisian"
	},
	{
		"abbr": "xh",
		"english": "Xhosa"
	},
	{
		"abbr": "yi",
		"english": "Yiddish"
	},
	{
		"abbr": "yo",
		"english": "Yoruba"
	},
	{
		"abbr": "za",
		"english": "Zhuang, Chuang"
	},
	{
		"abbr": "zu",
		"english": "Zulu"
	}
];

export default LANGUAGES;
